import { render, staticRenderFns } from "./ysRecord.vue?vue&type=template&id=199a1ab8"
import script from "./ysRecord.vue?vue&type=script&lang=js"
export * from "./ysRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports